import {
  FieldFilter,
  isEqualFilter,
  isInFilter,
  isLikeFilter,
  isNotEqualFilter,
  isNotInFilter,
  isNullFilter,
  isGreaterThanOrEqualFilter,
  isLessThanOrEqualFilter,
  isBetweenFilter,
} from "../FieldFilter.model";
import { FilterMenuItemType } from "../FilterMenu.model";
import { SingleActiveFilterItem } from "./SingleActiveFilterItem";
import { MultiActiveFilterItem } from "./MultiActiveFilterItem";
import { SearchActiveFilterItem } from "./SearchActiveFilterItem";
import { BooleanActiveFilterItem } from "./BooleanActiveFilterItem";
import { NumericActiveFilterItem } from "./NumericActiveFilterItem";
import { DateRangeActiveFilterItem } from "./DateRangeActiveFilterItem";

interface ActiveFilterItemProps<Field extends string> {
  size: "1" | "2" | "3";
  item: FilterMenuItemType<Field>;
  value: FieldFilter;
  viewOnly: boolean;
  onChange: (item: FilterMenuItemType<Field>) => void;
}

export function ActiveFilterItem<Field extends string>({
  size,
  item,
  value,
  viewOnly,
  onChange,
}: ActiveFilterItemProps<Field>) {
  return (
    <>
      {item.kind === "single" &&
        (isEqualFilter(value) ||
          isNotEqualFilter(value) ||
          isNullFilter(value)) && (
          <SingleActiveFilterItem<Field>
            {...item}
            size={size}
            value={value}
            onChange={onChange}
            viewOnly={viewOnly}
          />
        )}

      {item.kind === "multi" &&
        (isInFilter(value) || isNotInFilter(value) || isNullFilter(value)) && (
          <MultiActiveFilterItem<Field>
            {...item}
            size={size}
            value={value}
            onChange={onChange}
            viewOnly={viewOnly}
          />
        )}

      {item.kind === "search" && isLikeFilter(value) && (
        <SearchActiveFilterItem<Field>
          {...item}
          size={size}
          value={value}
          onChange={onChange}
          viewOnly={viewOnly}
        />
      )}

      {item.kind === "boolean" &&
        (isEqualFilter(value) ||
          isNotEqualFilter(value) ||
          isNullFilter(value)) && (
          <BooleanActiveFilterItem<Field>
            {...item}
            size={size}
            value={value}
            onChange={onChange}
            viewOnly={viewOnly}
          />
        )}

      {item.kind === "numeric" &&
        (isGreaterThanOrEqualFilter(value) ||
          isLessThanOrEqualFilter(value)) && (
          <NumericActiveFilterItem<Field>
            {...item}
            size={size}
            value={value}
            onChange={onChange}
            viewOnly={viewOnly}
          />
        )}

      {item.kind === "dateRange" &&
        (isBetweenFilter(value) ||
          isGreaterThanOrEqualFilter(value) ||
          isLessThanOrEqualFilter(value)) && (
          <DateRangeActiveFilterItem<Field>
            {...item}
            size={size}
            value={value}
            onChange={onChange}
            viewOnly={viewOnly}
          />
        )}
    </>
  );
}
